import React from 'react';

// Routing
import { Link, Outlet, useLocation } from 'react-router-dom';

// Material UI
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';

// MUI Icons
import ListAltIcon from '@mui/icons-material/ListAltOutlined';
import LocationOnIcon from '@mui/icons-material/LocationOnOutlined';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';


export default function LocationList() {
	const location = useLocation();

	return (
		<Paper
			padding='true'
			sx={{
				overflow: 'auto',
				boxShadow: '0',
				height: '100%',
				display: 'flex',
				flexDirection: 'column',
			}}
		>
			<Box
				sx={{
					bgcolor: '#FFFFFF',
					ml: 1,
				}}
			>
				<Tabs
					value={location.pathname}
					aria-label="locations list nav tabs"
					sx={{ height: '20px', }}
				>
					<Tab
						icon={<ListAltIcon />}
						iconPosition="start"
						label="List"
						component={Link}
						to="/list"
						value="/list"
						sx={{
							paddingTop: 0,
							border: 1,
							borderColor: '#CCCCCC',
							borderRadius: '10px 10px 0px 0px',
							'&:hover': {
								color: '#FFFFFF',
								backgroundColor: '#B1282E',
							  },
						}}
					/>
					<Tab
						icon={<LocationOnIcon />}
						iconPosition="start"
						label="Map"
						component={Link}
						to="/map"
						value="/map"
						sx={{
							paddingTop: 0,
							border: 1,
							borderColor: '#CCCCCC',
							borderRadius: '10px 10px 0px 0px',
							'&:hover': {
								color: '#FFFFFF',
								backgroundColor: '#B1282E',
							  },
						}}
					/>
					<Tab
						icon={<ReportProblemIcon />}
						iconPosition="start"
						label="Events"
						component={Link}
						to="/events"
						value="/events"
						sx={{
							paddingTop: 0,
							border: 1,
							borderColor: '#CCCCCC',
							borderRadius: '10px 10px 0px 0px',
							'&:hover': {
								color: '#FFFFFF',
								backgroundColor: '#B1282E',
							  },
						}}
					/>
				</Tabs>
			</Box>
			<Box
				sx={{
					bgcolor: '#FFFFFF',
					border: 1,
					borderColor: '#CCCCCC',
					borderRadius: 1,
					'& .MuiDataGrid-row:hover': {
						color: 'primary.main',
					},
					height: '100%',
				}}
			>
				<Outlet />
			</Box>
		</Paper>
	);
}